import { EMPLOYEE_JOB_STATS } from '../../constants';
import useEmployeeJobStats from './useEmployeeJobStats';

const useEmployeeKpiStats = (employeeId) => {
  const { isLoading, data } = useEmployeeJobStats({
    employeeId,
    ...EMPLOYEE_JOB_STATS,
    enabled: !!employeeId
  });

  const noShows = data?.noShows ?? 0;

  return {
    isLoading,
    shiftsWorked: data?.pastJobsWorked ?? 0,
    noShows,
    // Denominator is every past booking, not the worked count beside it: a no-show rate is
    // measured against the shifts the employee was expected at.
    noShowDenominator: noShows + (data?.pastJobs ?? 0)
  };
};

export default useEmployeeKpiStats;
